import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import { school_id } from 'utils/constants';
import httpClient from 'utils/http-client';
import { handleError } from '../../../utils/utils';
import { createParentFailure, createParentSuccess, fetchParentsStart } from '../actions';
import staffActionTypes from '../types';

export function* createParent({ payload }) {
  const { data, callback } = payload;
  const formData = data;
  try {
    const response = yield httpClient.post('/parents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-TENANT-ID': `${school_id}`,
      },
    });
    yield put(createParentSuccess(response.data));
    const data = {
      offset: 0,
      limit: 10,
    };
    yield put(fetchParentsStart(data));
    Notify('Parent created successfully', { position: 'top-right' });
    callback?.();
  } catch (error) {
    yield put(createParentFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onCreateParentStart() {
  yield takeLatest(staffActionTypes.CREATE_PARENT_START, createParent);
}
